/**
 * Oct 2026 — Legacy VOX host redirects.
 *
 * The new satisFIND marketing site (satisfind.com) is live, so two legacy VOX
 * landing pages redirect to it. Scoped STRICTLY to:
 *   • host  === "vox.satisfind.com"  (production only — preview is untouched)
 *   • path  === "/"                 → https://satisfind.com/
 *   • path  === "/satisfinder"      → https://satisfind.com/satisfinder
 *   • path  === "/satisfinder/"     → https://satisfind.com/satisfinder
 *
 * Everything else is preserved: pricing, surveys, policies, and ALL nested
 * satisFINDER app routes (/satisfinder/signup, /login, /dashboard, /kyc,
 * /payout, assignments, etc.) are never matched.
 *
 * This is a client-side temporary redirect (via location.replace, which does
 * not add a history entry — equivalent to a temporary/302-style redirect for
 * SPA static hosting). It is intentionally reversible: deleting this call
 * restores the old pages.
 */
export function getLegacyVoxRedirect(hostname, pathname) {
  if (hostname !== 'vox.satisfind.com') return null;
  if (pathname === '/') return 'https://satisfind.com/';
  if (pathname === '/satisfinder' || pathname === '/satisfinder/') {
    return 'https://satisfind.com/satisfinder';
  }
  return null;
}

export function applyLegacyVoxRedirect() {
  if (typeof window === 'undefined' || !window.location) return;
  const target = getLegacyVoxRedirect(window.location.hostname, window.location.pathname);
  if (target) window.location.replace(target);
}
